import { render, staticRenderFns } from "./adm-activar-licenca.vue?vue&type=template&id=4ad94acb&"
import script from "./adm-activar-licenca.vue?vue&type=script&lang=js&"
export * from "./adm-activar-licenca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports